// PricingPhilosophy.js
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const PricingPhilosophy = () => {
  const beliefs = [
    'Clarity belongs at the start, not the end',
    'A fee pays for work done, never for a promise',
    'Nobody should be left wondering what their money bought',
    'No charge should ever hang on an admission or a job offer'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
              How We Set Our Fees
            </h2>
            <p className="text-gray-600 text-base font-light leading-relaxed">
              Every case opens with a consultation, so cost follows the route you pick, where you are heading, and how much of the work you want us to carry.
            </p>
          </motion.div>

          {/* Beliefs Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-surface p-8 rounded-lg mb-6"
          >
            <p className="text-gray-700 text-base font-normal mb-6">
              The principles behind that:
            </p>
            <div className="space-y-4">
              {beliefs.map((belief, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 + (index * 0.1) }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle2 size={20} className="text-gray-700 flex-shrink-0 mt-0.5" />
                  <p className="text-gray-700 text-base font-light">
                    {belief}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Bottom Statement */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.7 }}
            className="text-center"
          >
            <p className="text-gray-700 text-base font-light leading-relaxed">
              Costs are set out in full once we have spoken, and always ahead of anything being paid.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PricingPhilosophy;
